import Vue from 'vue'
import Router from 'vue-router'
import PageStart from '@/components/PageStart'
import PageDetail from '@/components/PageDetail'
import PageTermsOfParticipation from '@/components/PageTermsOfParticipation'
import PageDataProtection from '@/components/PageDataProtection'
import PageImprint from '@/components/PageImprint'
import PageFaq from '@/components/PageFaq'
import RequestCode from '@/components/RequestCode'
import PageAccessibilityStatement from '@/components/PageAccessibilityStatement'

Vue.use(Router)

export function createRouter () {
    return new Router({
        mode: 'history',
        routes: [
            {
                path: '/',
                name: 'PageStart',
                component: PageStart
            },
            {
                path: '/projekte/:id',
                name: 'PageDetail',
                component: PageDetail
            },
            {
                path: '/impressum',
                name: 'Imprint',
                component: PageImprint
            },
            {
                path: '/datenschutz',
                name: 'DataProtection',
                component: PageDataProtection
            },
            {
                path: '/barrierefreiheit-erklaerung',
                name: 'AccessibilityStatement',
                component: PageAccessibilityStatement
            },
            {
                path: '/teilnahme-bedingungen',
                name: 'ParticipationTerms',
                component: PageTermsOfParticipation
            },
            {
                path: '/faq',
                name: 'FAQ',
                component: PageFaq
            },
            {
                path: '/code-anfordern',
                name: 'RequestCode',
                component: RequestCode
            }
        ]
    })
}



// WEBPACK FOOTER //
// ./src/router/index.js